import { AppointmentFormatV1 } from '@csp/dmdp-api-appointment-dto';

export enum VisitFormatType {
  PHONE = AppointmentFormatV1.PHONE,
  VIRTUAL = AppointmentFormatV1.VIRTUAL,
  IN_PERSON = AppointmentFormatV1.IN_PERSON,
  VIDEO = AppointmentFormatV1.VIDEO,
  HOME_VISIT = AppointmentFormatV1.HOME_VISIT,
}
